import React, { useEffect, useMemo } from 'react'
import ChatInput from './ChatInput'
import ChatMessages from './ChatMessages'
import useChannel from '../hooks/useChannel'
import { createConsumer } from '@rails/actioncable'
import { wsUrl } from '../consts/other'
import { useDispatch, useSelector } from 'react-redux'
import { HANDLE_CHAT_WS_MESSAGE, CLEAR_CHAT_MESSAGE, SET_CHAT_USER } from '../redux/chatMessagesReducer'
import { RootReducer } from '../redux/rootReducer'
import { useParams } from 'react-router-dom'

interface LessonScreenChatProps {
  user: 'student' | 'tutor'
}

const LessonScreenChat = ({ user }: LessonScreenChatProps) => {
  const actionCable = useMemo(() => createConsumer(wsUrl), [])
  const { subscribe, unsubscribe, send } = useChannel(actionCable)
  const reducerMessages = useSelector((state: RootReducer) => state.chatMessagesReducer.messages)

  const { lessonId } = useParams()
  const dispatch = useDispatch()

  const sendMessage = (message: string) => {
    send('create_message', { message })
  }

  const translateMessage = (messageId: number, message: string) => {
    const messageRecord = reducerMessages.find((m) => m.id === messageId)
    if (messageRecord?.translated) {
      dispatch(CLEAR_CHAT_MESSAGE({ id: messageId }))
    } else {
      send('translate_message', { message_id: messageId, message })
    }
  }

  useEffect(() => {
    dispatch(SET_CHAT_USER({ user }))
  }, [user, dispatch])

  useEffect(() => {
    const chanelSubscribe = async () => {
      subscribe(
        { channel: 'MessageChannel', role: user, lesson_id: lessonId },
        {
          received: (data) => {
            dispatch(HANDLE_CHAT_WS_MESSAGE(data))
          }
        }
      )
    }
    chanelSubscribe()
    return () => {
      unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="w-[25rem] bg-grayBackground flex flex-col justify-end max-h-[100vh] rounded-md overflow-hidden">
      <ChatMessages reducerMessages={reducerMessages} user={user} translateMessage={translateMessage} />
      <ChatInput sendMessage={sendMessage} />
    </div>
  )
}

export default LessonScreenChat
